import { create as createConfig, TDynamicCatalogConfig } from '../models/DynamicCatalogConfig'
import { create as createItem, TDynamicCatalogItem } from '../models/DynamicCatalogItem'
import { AbstractCatalogStore } from './AbstractCatalogStore'

export class DynamicCatalogStore extends AbstractCatalogStore<TDynamicCatalogConfig, TDynamicCatalogItem>{
  public constructor () {
    super({ createConfig, createItem })
  }
}
